<template>
  <div class="video-wrapper">
    <loading
      :height="40"
      color="#fff"
      :opacity="0"
      :width="40"
      :active.sync="is_buffering"
      :is-full-page="false"
      :can-cancel="false"
      background-color="transparent"
      class="loader"
    ></loading>
    <div class="player-container" v-show="show_player">
      <video ref="videoPlayer" class="video-js vjs-lime" controls></video>
    </div>
  </div>
</template>

<script>
import "@/scss/video-js.scss";
import videojs from "video.js";
import "@videojs/http-streaming";
import "videojs-contrib-quality-levels";
import "videojs-http-source-selector";
export default {
  name: "VideoPlayer",
  props: {
    type: {
      type: String,
      default: "hls",
    },
    src: {
      type: String,
      default: "",
    },
    initial: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      show_player: false,
      player: null,
      playerTimer: null,
      is_buffering: false,
      initPlayerTimer: null,
      playlistError: false,
    };
  },
  watch: {
    src(url) {
      let vm = this;
      vm.show_player = false;
      vm.initPlayer();
    },
  },
  mounted() {
    let vm = this;
    vm.$store.state.eventBus.$on("destroyPlayer", () => {
      vm.destroyPlayer();
    });
    vm.$store.state.eventBus.$on("skipIntro", (introEndTime) => {
      vm.player.currentTime(introEndTime);
    });
    vm.$store.state.eventBus.$on("exitFullScreen", (introEndTime) => {
      vm.player.exitFullScreen();
    });
    vm.initPlayerTimer = setTimeout(() => {
      vm.initPlayer();
      clearTimeout(vm.initPlayerTimer);
    }, 100);
  },
  beforeDestroy() {
    let vm = this;
    clearTimeout(vm.playerTimer);
    vm.player.dispose();
  },
  methods: {
    initPlayer() {
      let vm = this;
      vm.is_buffering = true;
      if (vm.type == "hls") {
        vm.axios({
          url: vm.src,
          method: "GET",
        })
          .then((response) => {
            vm.playlistError = false;
            vm.player = null;
            vm.destroyPlayer();
            vm.is_buffering = false;
            vm.playUsingHLS(vm.src);
            clearTimeout(vm.playerTimer);
          })
          .catch((error) => {
            vm.playerTimer = setTimeout(() => {
              vm.initPlayer();
            }, 2000);
          });
      }
      if (vm.type == "mp4") {
        vm.player = null;
        vm.destroyPlayer();
        vm.is_buffering = false;
        vm.show_player = true;
        vm.playUsingMp4(vm.src);
      }
    },
    destroyPlayer() {
      let vm = this;
      if (vm.player) {
        vm.player.dispose();
      }
    },
    playUsingHLS(src) {
      let vm = this;
      var options = {
        plugins: {
          httpSourceSelector: {
            default: "auto",
          },
        },
      };
      vm.player = videojs(
        vm.$refs.videoPlayer,
        options,
        function onPlayerReady() {
          vm.show_player = true;
          vm.player.on("fullscreenchange", function (evt) {
            setTimeout(function () {
              if (vm.player.isFullscreen()) {
                vm.$emit("fullscreen", true);
                if (typeof screen.orientation !== "undefined") {
                  screen.orientation
                    .lock("landscape")
                    .then((res) => {})
                    .catch((err) => {});
                }
              } else {
                vm.$emit("fullscreen", false);
                if (typeof screen.orientation !== "undefined") {
                  screen.orientation
                    .unlock()
                    .then((res) => {})
                    .catch((err) => {});
                }
              }
            });
          });
          vm.player.tech_.on("retryplaylist", (error) => {
            if (!vm.playlistError) {
              vm.playlistError = true;
              vm.axios({
                url: vm.src,
                method: "GET",
              })
                .then((response) => {})
                .catch((error) => {
                  vm.initPlayer();
                });
            }
          });

          vm.player.tech_.on("progress", function (e) {
            let currentTime = e.target.currentTime;
            vm.$emit("progress", currentTime);
          });
          vm.player.tech_.on("ended", function (e) {
            let currentTime = e.target.currentTime;
            vm.$emit("ended", currentTime);
          });
        }
      );

      vm.player.httpSourceSelector();
      vm.player.src({
        src: src,
        type: "application/x-mpegURL",
        withCredentials: false,
      });
      vm.player.play();
      // seek to time
      if (vm.initial) {
        vm.player.currentTime(vm.initial);
      }
      vm.$emit("started", null);
    },
    playUsingMp4(src) {
      let vm = this;
      vm.player = videojs(
        vm.$refs.videoPlayer,
        {
          controls: true,
          autoplay: true,
          preload: "auto",
          fluid: true,
          sources: [
            {
              src: src,
              type: "video/mp4",
            },
          ],
        },
        function onPlayerReady() {
          vm.show_player = true;
          vm.player.on("fullscreenchange", function (evt) {
            setTimeout(function () {
              if (vm.player.isFullscreen()) {
                vm.$emit("fullscreen", true);
                if (typeof screen.orientation !== "undefined") {
                  screen.orientation
                    .lock("landscape")
                    .then((res) => {})
                    .catch((err) => {});
                }
              } else {
                vm.$emit("fullscreen", false);
                if (typeof screen.orientation !== "undefined") {
                  screen.orientation
                    .unlock()
                    .then((res) => {})
                    .catch((err) => {});
                }
              }
            });
          });
          vm.player.tech_.on("progress", function (e) {
            let currentTime = e.target.currentTime;
            vm.$emit("progress", currentTime);
          });
          vm.player.tech_.on("ended", function (e) {
            let currentTime = e.target.currentTime;
            vm.$emit("ended", currentTime);
          });
        }
      );
      // seek to time
      if (vm.initial) {
        vm.player.currentTime(vm.initial);
      }
      vm.$emit("started", null);
    },
    onBack() {
      let vm = this;
      vm.destroyPlayer();
      vm.$emit("back", null);
    },
  },
};
</script>
<style lang="scss" >
.video-wrapper {
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  flex-direction: column;
  position: relative;
  .movie-video-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    padding-right: 20px;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    height: max-content;
    background: rgb(0, 0, 0);
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 1) 15%,
      rgba(0, 0, 0, 0) 100%
    );
    transition: 400ms ease-in-out;
    z-index: 999999;
    @media screen and (max-width: 800px) {
      top: 0px;
      opacity: 1;
      height: max-content;
    }
    &.hide_top_nav {
      top: -250px;
      transition: 400ms ease-in-out;
      @media screen and (max-width: 800px) {
        top: 0px;
        opacity: 0;
        height: max-content;
      }
    }
    .left-header-widget {
      display: flex;
      align-items: center;
      .btn-back {
        background: transparent;
        border: none;
        outline: none;
        img {
          width: 40px;
        }
      }
      .wathing-widget {
        font-weight: 500;
        color: #fff;
        font-size: 12px;
        margin-left: 30px;
      }
    }
    .logo {
      width: 118px;
      @media screen and (max-width: 800px) {
        width: 90px;
      }
    }
  }
  .player-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .video-js {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<style lang="scss">
//Player THEME

$color-primary: #95c01f !default;
$color-secondary: #2315ff !default;
$border-radius: 0.5em !default;

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}

.video-js.vjs-lime {
  border-radius: $border-radius;
  .vjs-big-play-button {
    width: 2em;
    height: 2em;
    line-height: 1.9em;
    border-radius: 1em;
    left: calc(50% - 1em);
    top: calc(50% - 1em);
    backdrop-filter: blur(4px);
    background-color: rgba(0, 0, 0, 0.6);
    border: 2px solid $color-primary;
    color: $color-primary;
  }

  &:hover,
  &:focus {
    .vjs-big-play-button {
      backdrop-filter: blur(4px);
      background-color: rgba(40, 40, 40, 0.6);
      border: 2px solid $color-primary;
      color: $color-primary;
    }
  }

  .vjs-loading-spinner {
    border: 3px solid rgba(0, 0, 0, 0.6);
    width: 45px;
    height: 45px;
    &:before,
    &:after {
      margin: -3px;
      animation: rotate 0.8s linear infinite;
      border-top-color: $color-primary;
    }
    &:after {
      display: none;
      border-top-color: $color-secondary;
    }
  }

  button:focus,
  .vjs-menu-item:focus {
    outline: none;
    color: $color-primary;
  }

  .vjs-control-bar {
    height: 5em;
    padding-top: 2em;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.7) 0%,
      rgba(0, 0, 0, 0.4) 35%,
      rgba(0, 0, 0, 0) 100%
    );
    border-bottom-left-radius: $border-radius;
    border-bottom-right-radius: $border-radius;
  }

  button.vjs-icon-cog {
    font-size: 1.3em;
  }

  .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 0.5em;
    backdrop-filter: blur(4px);
  }

  video {
    border-radius: $border-radius;
    &:focus {
      outline: none;
    }
  }

  .vjs-slider {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 10px;
  }

  .vjs-progress-holder {
    .vjs-load-progress {
      background-color: $color-primary;
      transition: width 0.15s linear;
    }
    .vjs-play-progress,
    .vjs-load-progress,
    .vjs-load-progress > div {
      border-radius: 10px;
    }
  }

  .vjs-menu li.vjs-menu-item:focus,
  .vjs-menu li.vjs-menu-item:hover,
  .js-focus-visible .vjs-menu li.vjs-menu-item:hover {
    &:not(.vjs-selected) {
      background-color: rgba(255, 255, 255, 0.3);
    }
  }
}
</style>